/**
 * api接口统一管理
 */
import {get, post } from '@/utils/request'
// 云店订单列表
export const getPageListOrder = (p, h, d) => post('/mall-trade/web/order/pageListOrder', p, h, d);
export const getOrderDetails = (p, h, d) => post('/mall-trade/web/order/getOrderById', p, h, d);
export const updatePriceById = (p, h, d) => post('/mall-trade/web/order/updatePriceById', p, h, d);

export const getPageListAfterSales = (p, h, d) => post('/mall-trade/web/order/pageListAfterSales', p, h, d)
export const getPageListSalesOrderMall = (p, h, d) => post('/storage/api/salesOrderMall/pageListSalesOrderMall', p, h, d)
export const getSalesOrderMallCount = (p, h, d) => post('/storage/api/salesOrderMall/salesOrderMallCount', p, h, d)
export const getListSalesOrderMallInfoById = (p, h, d) => post('/storage/api/salesOrderMall/listSalesOrderMallInfoById', p, h, d)


export const salesOrderMallDeliverGoods = (p, h, d) => post('/order/api/salesOrderMall/salesOrderMallDeliverGoods', p, h, d)
    // 售后列表
export const pageListSalesOrderMallAfterSalesService = (p, h, d) => post('/order/api/salesOrderMall/pageListSalesOrderMallAfterSalesService', p, h, d)
export const salesOrderMallAfterSalesServiceCount = (p, h, d) => post('/order/api/salesOrderMall/salesOrderMallAfterSalesServiceCount', p, h, d)
export const updateLogisticsInformation = (p, h, d) => post('/order/api/salesOrderMall/updateLogisticsInformation', p, h, d)

// 退款异常重试
export const refundExceptionRetrying = (p, h, d) => post('/order/api/salesOrderMall/refundExceptionRetrying', p, h, d);
// 单个商品发起售后
export const startAfterSalesSalesOrderMall = (p, h, d) => post('/order/api/salesOrderMall/startAfterSalesSalesOrderMall', p, h, d);
// 单个商品取消售后
export const cancelAfterSalesSalesOrderMall = (p, h, d) => post('/order/api/salesOrderMall/cancelAfterSalesSalesOrderMall', p, h, d);
// 批量发起售后
export const startAfterSalesBatch = (p, h, d) => post('/order/api/salesOrderMall/startAfterSalesBatch', p, h, d);
// 批量取消售后
export const cancelAfterSalesBatch = (p, h, d) => post('/order/api/salesOrderMall/cancelAfterSalesBatch', p, h, d);
// 批量退货入库
// export const saveInboundStorageBatch = (p, h, d) => post('/order/api/salesOrderMall/saveInboundStorageBatch', p, h, d);

// 批量退货入库
export const btnorderRemind = (p, h, d) => post('/order/api/salesOrderMall/orderRemind', p, h, d);